import 'bootstrap/dist/css/bootstrap.css';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import { useEffect, useState, useMemo, useRef } from 'react';
import InputMask from 'react-input-mask';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { OperadorDTO } from '../../../shared/dto/operadorDTO';
import { Gerente } from '../../../shared/model/gerente';
import Spinner from '../../../shared/spinner';
import SupervisorService from '../../../services/supervisorService';
import OperadorService from '../../../services/operadorService';
import CertificadoService from '../../../services/certificadoService';
import ViaCepService from '../../../services/viaCepService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import DualListBox from '../../../shared/DualListBox';
import PontoDeVendaService from '../../../services/pontoVendaService';
import { Button, Row, Col, Form } from 'react-bootstrap';

interface ListItem {
  id: number | string;
  nome: string;
}

function OperadorInclusaoAlteracao() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const [gerente, setGerente] = useState('');
  const [gerentes, setGerentes] = useState<Gerente[]>([]);
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [numeroCertificacao, setNumeroCertificacao] = useState('');
  const [certificado, setCertificado] = useState('');
  const [situacaoConsultaCertificado, setSituacaoConsultaCertificado] = useState<string | null>(null);
  const [situacaoCertificado, setSituacaoCertificado] = useState<string | null>(null);
  const [loadingCertificado, setLoadingCertificado] = useState(false);
  const [certificadosConsultados, setCertificadosConsultados] = useState<any[]>([]);
  const [certificadoSelecionado, setCertificadoSelecionado] = useState<any | null>(null);
  const [emails, setEmails] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');

  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [localidade, setLocalidade] = useState('');
  const [uf, setUf] = useState('');

  const isInitialMount = useRef(true);
  const [tipoVinculo, setTipoVinculo] = useState('PROMOTORA');
  const [loadingHierarquia, setLoadingHierarquia] = useState(false);
  const [pontosDeVenda, setPontosDeVenda] = useState<ListItem[]>([]);
  const [selectedPontosDeVenda, setSelectedPontosDeVenda] = useState<ListItem[]>([]);
  const [showPdvBox, setShowPdvBox] = useState(false);

  const [codigoExterno, setCodigoExterno] = useState('');
  const [loading, setLoading] = useState(false);
  const [certificados, setCertificados] = useState<any[]>([]);

  const supervisorService: SupervisorService = new SupervisorService();
  const operadorService: OperadorService = new OperadorService();
  const certificadoService: CertificadoService = new CertificadoService();
  const viaCepService: ViaCepService = new ViaCepService();
  const pontoDeVendaService: PontoDeVendaService = new PontoDeVendaService();

  const listarGerentes = async (pagina = 0, size = 10) => {
    try {
      const filtrosRequest: any = {
        page: pagina,
        size: size
      };

      const response = await supervisorService.listarTodosGerentes(pagina, size, filtrosRequest);
      if (tipo === 'inclusao' && response.data.content.length > 0) {
        setGerente(response.data.content[0].id.toString());
      }
      setGerentes(response.data.content);
    } catch (err) {
      console.error(err);
    }
  }

  const carregarHierarquiaPadrao = async (gerenteId: string) => {
      if (!gerenteId) {
          setPontosDeVenda([]);
          return;
      }
      setLoadingHierarquia(true);
      try {
          const response = await pontoDeVendaService.listarPorGerente(gerenteId);
          setPontosDeVenda(response.data || []);
      } catch (err) {
          console.error("Erro ao carregar PDVs do gerente:", err);
          setPontosDeVenda([]);
          setAlert({ message: "Erro ao carregar Pontos de Venda do Supervisor.", type: 'error' });
      } finally {
          setLoadingHierarquia(false);
      }
  };

  const carregarHierarquiaLivre = async () => {
      setLoadingHierarquia(true);
      try {
          const response = await pontoDeVendaService.listarTodosPontosVendasAtivos();
          setPontosDeVenda(response.data || []);
      } catch (err) {
          console.error("Erro ao carregar hierarquia livre:", err);
          setPontosDeVenda([]);
      } finally {
          setLoadingHierarquia(false);
      }
  };

  const listarOperadorPorId = async () => {
    setLoading(true);
    try {
      const response = await operadorService.listarOperadorPorId(id);
      const jsonOperador = response.data;

      const tipoVinculoDoOp = jsonOperador.tipoVinculo || 'PROMOTORA';
      setTipoVinculo(tipoVinculoDoOp);

      setGerente(jsonOperador.idGerente.toString()!);
      setNome(jsonOperador.nome);
      setCpf(jsonOperador.cpf);
      setEmails(jsonOperador.email);
      setNumeroCertificacao(jsonOperador.numeroCertificacao);
      setCertificado(jsonOperador.certificado || '');
      setTelefoneComercial(jsonOperador.foneComercial);
      setTelefoneCelular(jsonOperador.foneCelular);
      setSituacaoConsultaCertificado(jsonOperador.situacaoConsultaCertificado || null);
      setSituacaoCertificado(jsonOperador.situacaoCertificado || null);
      setCep(jsonOperador.cep);
      setLogradouro(jsonOperador.endereco);
      setNumero(jsonOperador.numeroEndereco);
      setComplemento(jsonOperador.complemento);
      setBairro(jsonOperador.bairro);
      setLocalidade(jsonOperador.cidade);
      setUf(jsonOperador.uf);
      setCodigoExterno(jsonOperador.codigoExterno);
      setCertificados(jsonOperador.certificados || []);

      if (jsonOperador.pontosDeVenda && Array.isArray(jsonOperador.pontosDeVenda) && jsonOperador.pontosDeVenda.length > 0) {
        setSelectedPontosDeVenda(jsonOperador.pontosDeVenda.map((p: any) => ({ id: p.id, nome: p.nome })));
        setShowPdvBox(true);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const handleSubmit = async (event: any) => {
    if (!cpfValidacao.isValid(cpf)) {
      setAlert({ message: 'CPF Inválido', type: 'warning' });
      return;
    } else {
      event.preventDefault();
      setLoading(true);
      let endereco : EnderecoDTO = new EnderecoDTO();
      endereco.cep = cep;
      endereco.logradouro = logradouro;
      endereco.numero = numero;
      endereco.complemento = complemento;
      endereco.bairro = bairro;
      endereco.uf = uf;
      endereco.localidade = localidade;

      let operadorDTO: OperadorDTO = new OperadorDTO();
      operadorDTO.tipoVinculo = tipoVinculo;
      operadorDTO.idsPontosDeVenda = selectedPontosDeVenda.map(p => p.id);

      operadorDTO.gerente = gerente;
      operadorDTO.id = id!;
      operadorDTO.nome = nome;
      operadorDTO.cpf = cpf;
      operadorDTO.email = emails;
      operadorDTO.numeroCertificacao = numeroCertificacao;
      operadorDTO.certificado = certificado;
      operadorDTO.enderecoDTO = endereco;
      operadorDTO.telefoneComercial = telefoneComercial;
      operadorDTO.telefoneCelular = telefoneCelular;
      operadorDTO.codigoExterno = codigoExterno;
      operadorDTO.situacaoConsultaCertificado = situacaoConsultaCertificado;
      operadorDTO.situacaoCertificado = situacaoCertificado;
      operadorDTO.certificados = certificados;

      try {
        await operadorService.incluirAlterarOperador(operadorDTO);
        setLoading(false);
        setAlert({ message: 'Operador salvo com sucesso!', type: 'success' });
      } catch (err: any) {
        setLoading(false);
        const msg = err.response?.data || err.message || "Ocorreu um erro ao salvar operador.";
        setAlert({ message: msg, type: 'error' });
        console.error(err);
      }
    }
  };

  const limparCampos = () => {
    setNome('');
    setCpf('');
    setEmails('');
    setTelefoneComercial('');
    setTelefoneCelular('');
    setCep('');
    setLogradouro('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setLocalidade('');
    setUf('');
    setCodigoExterno('')

    setSelectedPontosDeVenda([]);
    setShowPdvBox(false);
    setTipoVinculo('PROMOTORA');
    setCertificados([]);
    setCertificadosConsultados([]);
    setCertificadoSelecionado(null);
    setCertificado('');
    setNumeroCertificacao('');
  }

  const consultarCertificado = async () => {
    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length !== 11) {
      setAlert({ message: 'Informe um CPF válido para consultar o certificado.', type: 'warning' });
      return;
    }

    // Verifica se já existem certificados salvos no banco para este operador
    if (certificados && certificados.length > 0) {
      setCertificadosConsultados(certificados);
      setAlert({ message: 'Certificados encontrados na base de dados. Selecione um da tabela abaixo.', type: 'success' });
      return;
    }

    setLoadingCertificado(true);
    setCertificadosConsultados([]);
    setCertificadoSelecionado(null);
    setAlert({ message: 'Consultando certificados... Esta operação pode demorar alguns minutos. Por favor, aguarde.', type: 'warning' });
    try {
      const response = await certificadoService.consultarPorCpf(cpf);
      setSituacaoConsultaCertificado(response.sucesso ? 'SUCESSO' : 'ERRO');

      if (response.sucesso && response.dados && response.dados.length > 0) {
        setSituacaoCertificado('VALIDO');
        setCertificadosConsultados(response.dados);
        // Converte os certificados para o formato que o backend espera
        const certificadosMapeados = response.dados.map((cert: any) => ({
          numeroCertificacao: cert.numeroSerie || cert.numeroCertificado || '',
          certificadora: cert.emissor || cert.certificadora || '',
          certificado: cert.certificado || '',
          tipoCertificado: cert.tipoCertificado || '',
          nomeAgente: cert.nomeTitular || cert.nomeAgente || '',
          validadeCertificado: cert.dataValidadeFim || cert.dataValidade || ''
        }));
        setCertificados(certificadosMapeados);
        const primeiroCertificado = response.dados[0];
        setCertificadoSelecionado(primeiroCertificado);
        setNumeroCertificacao(primeiroCertificado.numeroSerie || primeiroCertificado.numeroCertificado || '');
        setCertificado(primeiroCertificado.certificado || '');
      } else if (response.sucesso && (!response.dados || response.dados.length === 0)) {
        setSituacaoCertificado('NAO_ENCONTRADO');
        setCertificadosConsultados([]);
        setAlert({ message: response.mensagem || 'Nenhum certificado encontrado para este CPF.', type: 'warning' });
      } else {
        setSituacaoCertificado('ERRO');
        setCertificadosConsultados([]);
        setAlert({ message: response.mensagem || 'Erro ao consultar certificado.', type: 'error' });
      }
    } catch (err: any) {
      setSituacaoConsultaCertificado('ERRO');
      setSituacaoCertificado('ERRO');
      setCertificadosConsultados([]);
      const msg = err.response?.data?.mensagem || err.message || 'Erro ao consultar certificado.';
      setAlert({ message: msg, type: 'error' });
      console.error(err);
    } finally {
      setLoadingCertificado(false);
    }
  };

  const selecionarCertificado = (cert: any) => {
    setCertificadoSelecionado(cert);
    setNumeroCertificacao(cert.numeroSerie || cert.numeroCertificado || cert.numeroCertificacao || '');
    setCertificado(cert.certificado || '');
  };

  const getBadgeClass = (situacao: string | null) => {
    if (!situacao) return 'bg-secondary';
    switch (situacao.toUpperCase()) {
      case 'VALIDO':
      case 'SUCESSO':
        return 'bg-success';
      case 'INVALIDO':
      case 'EXPIRADO':
      case 'ERRO':
        return 'bg-danger';
      case 'NAO_ENCONTRADO':
        return 'bg-warning text-dark';
      default:
        return 'bg-secondary';
    }
  };

  const formatarData = (dataStr: string | null) => {
    if (!dataStr) return '-';
    if (dataStr.includes('/')) return dataStr;
    try {
      const date = new Date(dataStr);
      if (isNaN(date.getTime())) return dataStr;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch {
      return dataStr;
    }
  };

  const getSituacaoCertificado = (cert: any) => {
    if (cert?.situacao) return cert.situacao;
    const dataRaw = cert?.dataValidade || cert?.dataValidadeFim || cert?.validadeCertificado;
    if (!dataRaw) return '-';
    const data = new Date(dataRaw);
    if (isNaN(data.getTime())) return '-';
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return data >= hoje ? 'VALIDO' : 'EXPIRADO';
  };

  const viaCep = async (cep: string) => {
    if (cep !== undefined && cep !== '' && cep.length === 10) {
      setLoading(true);
      const cepWithoutMask = cep.replace(/\D/g, '');
      try {
        const response = await viaCepService.viaCep(cepWithoutMask);
        const jsonViaCep = response.data;
        setLogradouro(jsonViaCep.logradouro);
        setLocalidade(jsonViaCep.localidade);
        setUf(jsonViaCep.uf);
        setBairro(jsonViaCep.bairro);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    }
  };

  useEffect(() => {
    if (tipo === 'alteracao') {
      listarOperadorPorId();
    }
    listarGerentes();
  }, [tipo, id]);

useEffect(() => {
      if (tipoVinculo === 'ENTIDADE') {
          if (!isInitialMount.current && !loading) {
              setSelectedPontosDeVenda([]);
          }
          carregarHierarquiaLivre();
      }
      else {

          if (gerente) {
              if (!isInitialMount.current && !loading) {
                  setSelectedPontosDeVenda([]);
              }
              carregarHierarquiaPadrao(gerente);
          } else {
              setPontosDeVenda([]);
              if (!loading) {
                setSelectedPontosDeVenda([]);
              }
          }
      }
      isInitialMount.current = false;
  }, [tipoVinculo, gerente]);


const availablePontosDeVenda = useMemo(() => {
    const selectedIds = new Set(selectedPontosDeVenda.map(p => String(p.id)));

    if (!Array.isArray(pontosDeVenda)) {
      return [];
    }

    return pontosDeVenda
      .map(p => ({ id: p.id!, nome: p.nome }))
      .filter(p => !selectedIds.has(String(p.id)))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }, [pontosDeVenda, selectedPontosDeVenda]);

  const handleMovePdvToSelected = (items: ListItem[]) => setSelectedPontosDeVenda(prev => [...prev, ...items].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMovePdvToAvailable = (items: ListItem[]) => {
    const idsToMove = new Set(items.map(i => i.id));
    setSelectedPontosDeVenda(prev => prev.filter(i => !idsToMove.has(i.id)));
  };
  const handleMoveAllPdvsToSelected = () => setSelectedPontosDeVenda([...pontosDeVenda.map(p => ({ id: p.id!, nome: p.nome }))].sort((a, b) => a.nome.localeCompare(b.nome)));
  const handleMoveAllPdvsToAvailable = () => setSelectedPontosDeVenda([]);

  return (
    <div className="container">
      {alert && (
        <CustomAlert
            message={alert.message}
            type={alert.type}
            onClose={()=> {
                setAlert(null);
                if (alert.type === 'success') {
                    navigate(-1);
                }
            }}
        />
      )}

      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <h5>Origens &gt; Operador &gt; {tipo === 'inclusao' ? 'Inclusão' : 'Alteração'}</h5>
              <Button id="App-button-cor-principal" onClick={() => navigate(-1)}>
                 Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row">
            <div className="col-xl">
              <label>Supervisor <span style={{ color: 'red' }}>*</span></label>
              <select
                className="form-select"
                value={gerente}
                onChange={(e) => setGerente(e.target.value)}
                disabled={tipoVinculo === 'ENTIDADE'}
              >
                {gerentes.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
              {tipoVinculo === 'ENTIDADE' && (
                <Form.Text className="text-muted">
                  A seleção do Supervisor é ignorada no Modo Livre.
                </Form.Text>
              )}
            </div>
          </div>

          <h5 className="mb-3">Modo de Vínculo (Ponto de Venda)</h5>
          <Form.Group as={Row} className="mb-3">
            <Col sm={10}>
              <Form.Check
                type="radio"
                label="Padrão (Vincular PDVs do Supervisor)"
                id="vinculo-padrao"
                name="tipoVinculoRadio"
                value="PROMOTORA"
                checked={tipoVinculo === 'PROMOTORA'}
                onChange={(e) => setTipoVinculo(e.target.value)}
              />
              <Form.Check
                type="radio"
                label="Livre (Vincular diretamente a qualquer PDV)"
                id="vinculo-entidade"
                name="tipoVinculoRadio"
                value="ENTIDADE"
                checked={tipoVinculo === 'ENTIDADE'}
                onChange={(e) => setTipoVinculo(e.target.value)}
              />
            </Col>
          </Form.Group>
          <hr className="my-4" />

          <div className="row">
            <div className="col-xl">
              <label>Nome <span style={{ color: 'red' }}>*</span></label>
              <input type="text" required className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>CPF <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>Nº da Certificação</label>
              <input type="text" className="form-control" value={numeroCertificacao} onChange={(e) => setNumeroCertificacao(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl">
              <label>Nome do Certificado</label>
              <input type="text" className="form-control" value={certificado} onChange={(e) => setCertificado(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl">
              <Button
                variant="primary"
                onClick={consultarCertificado}
                disabled={loadingCertificado}
              >
                {loadingCertificado ? 'Consultando...' : 'Consultar Certificados'}
              </Button>
              {situacaoCertificado && (
                <span className={`badge ms-2 ${getBadgeClass(situacaoCertificado)}`}>
                  {situacaoCertificado}
                </span>
              )}
            </div>
          </div>

          {certificadosConsultados.length === 0 && situacaoCertificado === 'NAO_ENCONTRADO' && (
            <div className="alert alert-warning mt-3">
              Nenhum certificado encontrado para este CPF.
            </div>
          )}

          <hr className="my-4" />
          <h5 className="mb-3">Vínculos de Ponto de Venda</h5>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Check
                type="checkbox"
                id="pdvCheckbox"
                label="Vincular ao Ponto de Venda"
                checked={showPdvBox}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setShowPdvBox(isChecked);
                  if (!isChecked) {
                    setSelectedPontosDeVenda([]);
                  }
                }}
              />
            </Col>
          </Row>

          {loadingHierarquia && <Spinner loading={loadingHierarquia} />}

          {!loadingHierarquia && showPdvBox && (
            <Row className="mb-4">
               <label>
                {tipoVinculo === 'PROMOTORA'
                  ? 'PDVs (Disponíveis do Supervisor selecionado)'
                  : 'PDVs (Todos disponíveis no sistema)'}
               </label>
               <Col md={12}>
                  <DualListBox
                      availableItems={availablePontosDeVenda}
                      selectedItems={selectedPontosDeVenda}
                      onMoveToSelected={handleMovePdvToSelected}
                      onMoveAllToSelected={handleMoveAllPdvsToSelected}
                      onMoveToAvailable={handleMovePdvToAvailable}
                      onMoveAllToAvailable={handleMoveAllPdvsToAvailable}
                      availableLabel="PDVs Disponíveis"
                      selectedLabel="PDVs Vinculados"
                  />
               </Col>
            </Row>
          )}

          <div className="row">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';') <span style={{ color: 'red' }}>*</span></label>
              <input type="text" required className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            {loading ? <Spinner loading={loading} /> : false}
            <div className="col-md-2">
              <label>CEP <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="99.999-999" type="text" className="form-control" required
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número <span style={{ color: 'red' }}>*</span></label>
              <input type="number" className="form-control" required value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-md">
              <label>Bairro <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="aa" type="text" required className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <label className="form-label">Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-md">
              <label className="form-label">Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <div className="row">
                <div className="col-md">
                  <label>Código Externo</label>
                  <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <div>
            <hr className="my-4" />
            <h5 className="mb-3">Certificados - Selecione um:</h5>
            {certificados && certificados.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>Certificado</th>
                      <th>Tipo</th>
                      <th>Número de Série</th>
                      <th>Emissor</th>
                      <th>Data de Validade</th>
                      <th style={{ textAlign: 'center' }}>Situação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {certificados.map((cert, index) => (
                      <tr
                        key={index}
                        className={certificadoSelecionado === cert ? 'table-primary' : ''}
                        style={{ cursor: 'pointer' }}
                        onClick={() => selecionarCertificado(cert)}
                      >
                        <td style={{ textAlign: 'center' }}>
                          <input
                            type="radio"
                            name="certificadoSelecionado"
                            checked={certificadoSelecionado === cert}
                            onChange={() => selecionarCertificado(cert)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>
                        <td>{cert.certificado || cert.numeroCertificacao || '-'}</td>
                        <td>{cert.tipoCertificado || '-'}</td>
                        <td>{cert.numeroSerie || cert.numeroCertificado || cert.numeroCertificacao || '-'}</td>
                        <td>{cert.emissor || cert.certificadora || '-'}</td>
                        <td>{formatarData(cert.dataValidade || cert.dataValidadeFim || cert.validadeCertificado)}</td>
                        <td style={{ textAlign: 'center' }}>
                          <span className={`badge ${getBadgeClass(getSituacaoCertificado(cert))}`}>
                            {getSituacaoCertificado(cert)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-info">
                Nenhum certificado vinculado. Clique em "Consultar Certificados" para buscar.
              </div>
            )}
          </div>

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Operador' : 'Salvar Operador'}</button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default OperadorInclusaoAlteracao;
